import { all, call, put, takeEvery } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from './actions';


function* fetchProducts() {
    try {
        const response = yield call(AxiosCall, '/shop/get_products/');
        yield put(actions.fetchProductsSuccess(response.data.results));

    } catch (e) {
        // Error handled silently
    }
}

function* fetchProductsByPage(action) {
    try {
        const response = yield call(AxiosCall, `/shop/get_products/?page=${action.payload.page}`);


        yield put(actions.fetchProductsByPageSuccess(response.data))
    } catch (e) {
        yield put({ type: actions.FETCH_PRODUCTS_BY_PAGE.FAILURE, message: e.message })
    }
}


function* fetchProductsByFilter(action) {
    try {
        const response = yield call(AxiosPost, `/shop/search_products/?page=${action.payload.page}`, action.payload.filters);


        yield put(actions.fetchProductsByFilterSuccess(response.data))
    } catch (e) {
        yield put({ type: actions.FETCH_PRODUCTS_BY_FILTER.FAILURE, message: e.message })
    }
}




export default function* rootSaga() {
    yield all([
        takeEvery(actions.FETCH_PRODUCTS.REQUEST, fetchProducts),
        takeEvery(actions.FETCH_PRODUCTS_BY_PAGE.REQUEST, fetchProductsByPage),
        takeEvery(actions.FETCH_PRODUCTS_BY_FILTER.REQUEST, fetchProductsByFilter),
    ]
    )
}
